import React, { useEffect, useState } from 'react';
import { t } from 'ttag';
import { CTA } from '../../../../general/Button';

type CopyLinkButtonProps = {
    link: string;
    secondary?: boolean;
    small?: boolean;
    className?: string;
    // for the banner's button, where the words aren't the same
    label?: string;
};

const copy = async (text: string): Promise<boolean> => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (e) {
        // not allowed or not there: the old way
        const field = document.createElement('textarea');
        field.value = text;
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();

        try {
            return document.execCommand('copy');
        } catch (err) {
            return false;
        } finally {
            document.body.removeChild(field);
        }
    }
};

const CopyLinkButton = ({ link, secondary, small, className, label }: CopyLinkButtonProps) => {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied) return;

        const timer = setTimeout(() => setCopied(false), 2000);

        return () => clearTimeout(timer);
    }, [copied]);

    return (
        <CTA
            type="button"
            secondary={secondary}
            small={small}
            className={className}
            onClick={async () => setCopied(await copy(link))}
        >
            <span>{copied ? t`Copied` : label ?? t`Copy`}</span>
        </CTA>
    );
};

export default CopyLinkButton;
